import { render, staticRenderFns } from "./rotorDetail.vue?vue&type=template&id=84f79cec&scoped=true&"
import script from "./rotorDetail.vue?vue&type=script&lang=js&"
export * from "./rotorDetail.vue?vue&type=script&lang=js&"
import style0 from "./rotorDetail.vue?vue&type=style&index=0&id=84f79cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f79cec",
  null
  
)

export default component.exports